const fr = {
  translation: {
    logo: {
      tagline: 'Services de nettoyage'
    },
    nav: {
      home: 'Accueil',
      services: 'Tarifs',
      booking: 'Réserver',
      myBookings: 'Mes Réservations',
      admin: 'Admin',
      profile: 'Mon Profil',
      login: 'Connexion',
      logout: 'Déconnexion',
      contact: 'Contact'
      ,availability: 'Mes Disponibilités'
    },
    hero: {
      title: 'Maison impeccable, sans lever le petit doigt.',
      subtitle: 'Service de nettoyage professionnel pour votre tranquillité',
      cta: 'Réserver Maintenant'
    },
    home: {
      whyChoose: 'Pourquoi Choisir Tout Propre?',
      professionalTeam: 'Équipe Professionnelle',
      professionalTeamDesc: 'Experts en nettoyage vérifiés et assurés',
      transparentPricing: 'Tarification Transparente',
      transparentPricingDesc: 'Aucuns frais cachés, devis instantanés',
      flexibleScheduling: 'Horaires Flexibles',
      flexibleSchedulingDesc: 'Réservez à votre convenance',
      qualityGuarantee: 'Garantie de Qualité',
      qualityGuaranteeDesc: 'Garantie de satisfaction de 48 heures',
      howItWorks: 'Comment Ça Marche',
      browseServices: 'Consulter les Tarifs',
      browseServicesDesc: 'Consultez nos tarifs et personnalisez votre nettoyage',
      chooseDateTime: 'Choisir la Date et l’Heure',
      chooseDateTimeDesc: 'Choisissez la date et l’heure qui vous conviennent',
      getConfirmed: 'Recevoir la Confirmation',
      getConfirmedDesc: 'Notre équipe confirme et arrive à l’heure avec tout le matériel',
      enjoyCleanliness: 'Profiter de la Propreté',
      enjoyCleanlinessDesc: 'Détendez-vous pendant que nous rendons votre maison impeccable',
      testimonials: 'Ce Que Disent Nos Clients',
      testimonialOne: 'Excellent service! Ma maison n’a jamais été aussi belle. Je recommande vivement!',
      testimonialTwo: 'Professionnels, fiables et abordables. Exactement ce qu’il nous fallait!',
      testimonialThree: 'La réservation en ligne est simple et la qualité du travail est remarquable!',
      livingRoomAlt: 'Salon moderne impeccable',
      livingRoomTeamAlt: 'Équipe de nettoyage professionnelle dans un salon moderne',
      kitchenAlt: 'Cuisine moderne lumineuse et propre',
      kitchenTeamAlt: 'Équipe de nettoyage professionnelle dans une cuisine lumineuse',
      bedroomAlt: 'Chambre paisible fraîchement nettoyée',
      bedroomTeamAlt: 'Équipe de nettoyage professionnelle rendant une chambre impeccable'
    },
    services: {
      title: 'Tarifs',
      regular: 'Nettoyage Régulier',
      regularDesc: 'Entretien routinier de votre maison',
      deepCleaning: 'Grand Ménage',
      deepDesc: 'Nettoyage en profondeur de chaque coin',
      moveOut: 'Ménage de Déménagement',
      moveOutDesc: 'Nettoyage complet pour déménagement',
      priceFrom: 'À partir de',
      selectService: 'Sélectionner le Service',
      customizeCleaning: 'Personnalisez votre nettoyage',
      estimatedDuration: 'Durée estimée : {{hours}} h {{minutes}} min',
      bookConfigured: 'Réserver',
      pricingSummary: 'Tarification résidentielle',
      baseCleaning: 'Nettoyage de base',
      baseCleaningIncludes: 'Prix de départ avec les quantités incluses',
      includedQuantity: '{{count}} inclus(e)',
      includedInBase: '{{count}} inclus(e) dans le nettoyage de base',
      configureAndBook: 'Configurer et réserver',
      backToServices: 'Retour aux services',
      configurationEyebrow: 'Personnalisation du service',
      configurationInstructions: 'Ajustez simplement chaque quantité. Le prix et la durée se mettent à jour automatiquement.',
      roomOrOption: 'Pièce ou option',
      quantity: 'Quantité',
      decreaseQuantity: 'Réduire la quantité',
      increaseQuantity: 'Augmenter la quantité',
      yourCleaning: 'Votre nettoyage',
      totalPrice: 'Prix total',
      totalDuration: 'Durée estimée',
      chooseDate: 'Choisir la date et l’heure',
      totalUpdatesAutomatically: 'Les disponibilités seront calculées selon cette durée.',
      repeatCleanings: 'Nettoyages subséquents',
      frequency: 'Fréquence',
      discount: 'Rabais',
      within30Days: 'Nouvelle réservation dans les 30 jours',
      within15Days: 'Nouvelle réservation dans les 15 jours',
      weekly: 'Nouvelle réservation dans les 7 jours',
      discountAutomatic: 'Le meilleur rabais admissible est appliqué automatiquement selon votre réservation précédente.',
      loadError: 'Impossible de charger les services'
    },
    booking: {
      title: 'Réserver un Service',
      editTitle: 'Modifier la Réservation',
      edit: 'Modifier la Réservation',
      updateBooking: 'Enregistrer les Modifications',
      updateSuccess: 'Réservation mise à jour avec succès!',
      cannotEdit: 'Cette réservation ne peut plus être modifiée',
      cancelBooking: 'Annuler la Réservation',
      cancelConfirm: 'Voulez-vous vraiment annuler cette réservation?',
      cancelSuccess: 'Réservation annulée avec succès',
      cancelError: 'Impossible d’annuler la réservation',
      selectService: 'Sélectionner un Service',
      selectDate: 'Sélectionner la Date',
      selectTime: 'Sélectionner l\'Heure',
      cleaningAddress: 'Adresse Complète du Nettoyage',
      street: 'Adresse',
      unit: 'Appartement / Unité (facultatif)',
      unitRequired: 'Appartement / Unité / Complément d’adresse',
      city: 'Ville',
      province: 'Province',
      postalCode: 'Code postal',
      notes: 'Notes Supplémentaires',
      notesPlaceholder: 'Des demandes particulières?',
      requiredFields: 'Veuillez remplir tous les champs obligatoires',
      createError: 'Impossible de créer la réservation',
      availabilityError: 'Impossible de charger les disponibilités',
      chooseServiceAndDate: 'Choisissez un service et une date pour voir les heures disponibles.',
      chooseServiceFirst: 'Choisissez un service pour voir les dates disponibles.',
      available: 'Disponible',
      unavailable: 'Indisponible',
      scheduleClosed: 'Aucune heure de service n’est disponible ce jour-là.',
      remainingCapacity: '{{remaining}} place(s) disponible(s) sur {{capacity}}',
      noBookings: 'Aucune réservation pour le moment.',
      bookAService: 'Réserver un service!',
      date: 'Date',
      price: 'Prix',
      status: 'Statut',
      totalPrice: 'Prix Total',
      book: 'Confirmer la Réservation',
      bookingSuccess: 'Réservation confirmée avec succès!',
      myBookings: 'Mes Réservations',
      currentBookings: 'Réservations en cours',
      bookingHistory: 'Réservations terminées ou annulées',
      noCurrentBookings: 'Aucune réservation en cours.',
      noBookingHistory: 'Aucune réservation terminée ou annulée.',
      discountApplied: 'Rabais de {{percentage}} % appliqué',
      cleaningSummary: 'Résumé du nettoyage',
      estimatedDuration: 'Durée estimée'
    },
    auth: {
      login: 'Connexion',
      signup: 'Inscription',
      email: 'E-mail',
      password: 'Mot de Passe',
      passwordHelp: 'Utilisez au moins 8 caractères',
      name: 'Nom Complet',
      signInGoogle: 'Se connecter avec Google',
      getStarted: 'Commencer',
      dontHaveAccount: 'Pas encore de compte?',
      alreadyHaveAccount: 'Vous avez déjà un compte?',
      forgotPassword: 'Mot de passe ou identifiant oublié?',
      emailIsUsername: 'Votre identifiant est votre adresse e-mail. Saisissez-la pour recevoir un lien de réinitialisation.',
      sendResetLink: 'Envoyer le lien',
      resetEmailSent: 'Si ce courriel est inscrit, un lien a été envoyé.',
      resetEmailInstructions: 'Si un compte correspond à cette adresse, vous recevrez un lien valide pendant une heure. Vérifiez également vos courriels indésirables.',
      resetRequestError: 'Impossible de demander la réinitialisation',
      backToLogin: 'Retour à la connexion',
      createNewPassword: 'Créer un nouveau mot de passe',
      saveNewPassword: 'Enregistrer le nouveau mot de passe',
      passwordResetSuccess: 'Mot de passe réinitialisé avec succès',
      resetPasswordError: 'Impossible de réinitialiser le mot de passe',
      invalidResetLink: 'Ce lien est invalide ou a expiré.',
      requestNewLink: 'Demander un nouveau lien'
    },
    profile: {
      title: 'Mon Profil',
      personalInformation: 'Renseignements Personnels',
      phone: 'Numéro de téléphone',
      saveProfile: 'Enregistrer le Profil',
      saved: 'Profil mis à jour avec succès',
      loadError: 'Impossible de charger le profil',
      saveError: 'Impossible de mettre à jour le profil',
      changePassword: 'Changer le Mot de Passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      updatePassword: 'Mettre à Jour le Mot de Passe',
      passwordMismatch: 'Les nouveaux mots de passe ne correspondent pas',
      passwordSaved: 'Mot de passe mis à jour avec succès',
      passwordError: 'Impossible de mettre à jour le mot de passe'
    },
    admin: {
      dashboard: 'Tableau de Bord Admin',
      bookingRequests: 'Demandes de Réservation',
      filterByStatus: 'Filtrer par statut',
      allStatuses: 'Tous les statuts',
      bookingCount: '{{count}} réservation(s)',
      noBookingsForStatus: 'Aucune réservation ne correspond à ce statut.',
      services: 'Tarifs',
      users: 'Utilisateurs',
      registeredUsers: 'Utilisateurs inscrits',
      userCount: '{{count}} utilisateur(s)',
      noUsers: 'Aucun utilisateur inscrit.',
      loadUsersError: 'Impossible de charger les utilisateurs',
      role: 'Rôle',
      accountStatus: 'Statut du compte',
      registeredAt: 'Date d’inscription',
      active: 'Actif',
      inactive: 'Inactif',
      roles: {
        customer: 'Client',
        collaborator: 'Collaborateur',
        admin: 'Administrateur'
      },
      manageServices: 'Gérer les Tarifs',
      addService: 'Ajouter un Service',
      editRates: 'Modifier les tarifs',
      itemIcon: 'Icône',
      createGeneralCleaning: 'Préparer le Nettoyage Général',
      editService: 'Modifier le Service',
      titleEn: 'Titre (anglais)',
      titleFr: 'Titre (français)',
      descriptionEn: 'Description (anglais)',
      descriptionFr: 'Description (français)',
      detailsEn: 'Détails (anglais)',
      detailsFr: 'Détails (français)',
      onePerLine: 'Un détail par ligne',
      price: 'Prix',
      durationHours: 'Durée de base (heures)',
      enableConfigurator: 'Permettre au client de choisir les pièces et options',
      configuratorHelp: 'Le prix et la durée augmentent automatiquement selon les quantités choisies.',
      configurationItems: 'Pièces et options configurables',
      loadDefaultItems: 'Charger les 12 options par défaut',
      addConfigurationItem: 'Ajouter une option',
      itemNameEn: 'Nom (anglais)',
      itemNameFr: 'Nom (français)',
      defaultQuantity: 'Quantité incluse',
      additionalPrice: 'Prix par unité supplémentaire',
      additionalMinutes: 'Minutes par unité supplémentaire',
      capacityPerSlot: 'Réservations acceptées par plage horaire',
      affectsOtherServices: 'Partager les disponibilités avec les autres services',
      affectsOtherServicesHelp: 'Lorsque cette option est activée, ce service utilise la même équipe que tous les autres services activés. Les réservations qui se chevauchent bloquent tout le groupe partagé.',
      sharedSchedule: 'Horaire d’équipe partagé',
      perTimeSlot: 'par plage horaire',
      serviceSaved: 'Service enregistré avec succès',
      serviceSaveError: 'Impossible d’enregistrer le service',
      removeServiceConfirm: 'Retirer ce service?',
      serviceRemoved: 'Service retiré avec succès',
      serviceRemoveError: 'Impossible de retirer le service',
      duplicate: 'Dupliquer',
      serviceDuplicated: 'Service dupliqué avec succès',
      serviceDuplicateError: 'Impossible de dupliquer le service',
      reorderService: 'Réorganiser le service',
      moveUp: 'Déplacer vers le haut',
      moveDown: 'Déplacer vers le bas',
      serviceOrderUpdated: 'Ordre des services mis à jour',
      serviceOrderError: 'Impossible de modifier l’ordre des services',
      settings: 'Paramètres',
      workingHours: 'Heures de Travail',
      alertEmails: 'E-mails d\'Alerte',
      availability: 'Disponibilité',
      availableDates: 'Dates Disponibles — 3 Prochains Mois',
      availableDatesInfo: 'Chaque clic réduit la capacité de 2 à 1, puis à 0 personne. Un autre clic revient à 2 personnes. Enregistrez ensuite les changements.',
      saveAvailableDates: 'Enregistrer les Dates Disponibles',
      availabilityUpdated: 'Dates disponibles mises à jour avec succès',
      availabilityUpdateError: 'Impossible de mettre à jour les dates disponibles',
      configureDayHours: 'Définissez les heures de travail de ce jour de la semaine avant d’ouvrir cette date.',
      confirmBooking: 'Confirmer',
      rejectBooking: 'Rejeter',
      addEmail: 'Ajouter un E-mail',
      saveChanges: 'Enregistrer les Changements',
      date: 'Date',
      service: 'Service',
      customer: 'Client',
      address: 'Adresse',
      status: 'Statut',
      actions: 'Actions',
      pending: 'En attente',
      confirmed: 'Confirmée',
      completed: 'Terminée',
      cancelled: 'Annulée',
      enterEmail: 'Saisissez une adresse e-mail',
      remove: 'Retirer',
      closed: 'Fermé',
      workingHoursInfo: 'Configurez vos heures de travail et disponibilités dans cette section.',
      start: 'Début',
      end: 'Fin',
      saveWorkingHours: 'Enregistrer les Heures de Travail',
      workingHoursUpdated: 'Heures de travail mises à jour avec succès',
      workingHoursUpdateError: 'Impossible de mettre à jour les heures de travail',
      loadBookingsError: 'Impossible de charger les réservations',
      loadSettingsError: 'Impossible de charger les paramètres',
      bookingUpdated: 'Réservation mise à jour avec succès',
      bookingUpdateError: 'Impossible de mettre à jour la réservation',
      approximateStartTime: 'Heure approximative de début',
      startTimeRequired: 'Saisissez l’heure approximative avant de confirmer.',
      assignedCollaborator: 'Collaborateur', selectCollaborator: 'Sélectionner un collaborateur', collaboratorRequired: 'Sélectionnez un collaborateur disponible avant de confirmer.',
      twoPeople: '2 personnes disponibles', onePerson: '1 personne disponible', noPeople: 'Aucune personne disponible',
      roleUpdated: 'Rôle mis à jour', roleUpdateError: 'Impossible de modifier le rôle', viewAvailability: 'Voir l’agenda',
      availabilityOf: 'Disponibilités de {{name}}', noAvailability: 'Aucune disponibilité enregistrée.',
      deleteBookingConfirm: 'Supprimer définitivement cette demande de réservation? Cette action est irréversible.',
      bookingDeleted: 'Demande de réservation supprimée',
      bookingDeleteError: 'Impossible de supprimer la demande de réservation',
      enterEmailError: 'Veuillez saisir une adresse e-mail',
      emailAdded: 'Adresse d’alerte ajoutée',
      emailAddError: 'Impossible d’ajouter l’adresse',
      emailRemoved: 'Adresse d’alerte retirée',
      emailRemoveError: 'Impossible de retirer l’adresse',
      days: {
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche'
      }
    },
    collaborator: {
      title: 'Mes Disponibilités', instructions: 'Sélectionnez vos jours et heures disponibles pour les trois prochains mois.',
      addDay: 'Rendre cette journée disponible', removeDay: 'Retirer cette journée', save: 'Enregistrer mes disponibilités',
      saved: 'Disponibilités enregistrées', loadError: 'Impossible de charger les disponibilités', saveError: 'Impossible d’enregistrer les disponibilités'
    },
    icons: {
      basement: 'Sous-sol', toilet: 'Toilette', bath: 'Salle de bain', bed: 'Lit', kitchen: 'Cuisine',
      sofa: 'Canapé', dining: 'Salle à manger', stairs: 'Escalier', window: 'Fenêtre',
      oven: 'Four', fridge: 'Réfrigérateur', cabinet: 'Armoire', linen: 'Linge de lit', sparkles: 'Autre'
    },
    footer: {
      description: 'Services de nettoyage professionnels pour une maison impeccable.',
      contact: 'Nous Joindre',
      email: 'E-mail',
      phone: 'Téléphone',
      rights: 'Tous droits réservés.'
    },
    contact: {
      title: 'Nous Joindre',
      address: 'Adresse (facultatif)',
      message: 'Message',
      send: 'Envoyer',
      sent: 'Votre message a été envoyé avec succès.',
      sendError: 'Impossible d’envoyer votre message. Veuillez réessayer.',
      tooMany: 'Trop de messages ont été envoyés. Veuillez réessayer plus tard.'
    },
    common: {
      welcome: 'Bienvenue',
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      save: 'Enregistrer',
      edit: 'Éditer',
      delete: 'Supprimer',
      close: 'Fermer',
      select: 'Sélectionner',
      previousImage: 'Image précédente',
      nextImage: 'Image suivante',
      chooseCarouselImage: 'Choisir une image du carrousel',
      showImage: 'Afficher l’image {{number}}',
      fillAllFields: 'Veuillez remplir tous les champs',
      passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
      enterName: 'Veuillez saisir votre nom',
      authenticationSuccess: 'Authentification réussie!',
      signUpFailed: 'Échec de l’inscription',
      loginFailed: 'Échec de la connexion'
    }
  }
};

export default fr;
